import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_entity_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type:fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  contact_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
   acl_config :fromDatatype.JsonDatatypeInterface;
   acl_policy :fromDatatype.JsonDatatypeInterface;
}
export class bl_fi_mst_entity_line_RowClass
  implements bl_fi_mst_entity_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type:fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  contact_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  acl_config :fromDatatype.JsonDatatypeInterface;
  acl_policy :fromDatatype.JsonDatatypeInterface;
}
